import {useState, useEffect} from 'react';
import OralSupplierList from '../components/OralSupplierList';
import oralSuppliersImage from '../assets/image/icon-suppliers.png';

import * as OralSupplierApi from '../api/OralSupplierApi';
import PageShell from '../components/PageShell';

export default function OralSuppliers() {
  const [oralSuppliers, setOralSuppliers] = useState([]);

  useEffect(() => {
    OralSupplierApi.getAllOralSupplier()
      .then((res) => {
        if (Array.isArray(res)) {
          setOralSuppliers(res);
        } else {
          console.error('API returned non-array:', res);
          setOralSuppliers([]);
        }
      })
      .catch((err) => {
        console.error('Failed to fetch oral suppliers:', err);
        setOralSuppliers([]);
      });
  }, []);

  return (
    <PageShell title="Oral Hygiene Suppliers" titleIcon={oralSuppliersImage} showBackButton={true}>
      <ul className="list-style-none">
        {oralSuppliers.map((oralSupplier) => (
          <OralSupplierList
            key={oralSupplier.id}
            id={oralSupplier.id}
            title={oralSupplier.title}
            image={oralSupplier.cover_image}
          />
        ))}
      </ul>
    </PageShell>
  );
}
